module.exports = "/images/vendor/desiigner-svg/svg/places/india.svg?e94c9baf8381b33c4447b4cd0b53d233";